<div *ngIf="logo"><img [src]="logo" width="50" /></div>
<div *ngIf="!logo && initials">
  <div class="initialsBubble" [ngStyle]="{ 'background-color': backColor }">{{ initials }}</div>
</div>
<div *ngIf="!logo && !initials"><img src="../../../../assets/img/camera-off.svg" width="50" /></div>
